export const mapResearchDataToTableRows = researchData => {
  if (!researchData || !Array.isArray(researchData.renderFields)) {
    return []
  }

  return researchData.renderFields
    .map((field, index) => ({
      id: `${field.title}-${index}`,
      label: field.title ?? '',
      value: field.value?.trim() || '—'
    }))
    .filter(e => e.label)
}
